import * as Updates from 'expo-updates';

import { fromPromise } from 'xstate5';

import { checkForInitialUpdate, checkForUpdate } from '../services';

// ─── Actors ──────────────────────────────────────────────────────────────────

const checkForInitialUpdateActor = fromPromise<
  Awaited<ReturnType<typeof checkForInitialUpdate>>,
  Parameters<typeof checkForInitialUpdate>[0]
>(async ({ input }) => checkForInitialUpdate(input));

const checkForUpdateActor = fromPromise(async () => checkForUpdate());

const restartApp = fromPromise(async () => Updates.reloadAsync());

// ─── External Actors ─────────────────────────────────────────────────────────

const storeUpdateContext = fromPromise(async () => {});

// ─────────────────────────────────────────────────────────────────────────────

export const Actors = {
  checkForInitialUpdate: checkForInitialUpdateActor,
  checkForUpdate: checkForUpdateActor,
  restartApp,
  storeUpdateContext,
};
